import { get } from "lodash";

export const isFetching = (state, key) =>
  get(state, ["approvalWorkflows", "spaces", "fetching", "byKey", key]);
export const space = (state, key) =>
  get(state, ["approvalWorkflows", "spaces", "space", "byKey", key], {});
